import { type ChangeEventHandler } from 'react';
import styles from './filter.module.scss';

function Filter(props: FilterProps) {
	const filterCheckboxID = `${props.filterFor}-${props.filterValue}-checkbox`
		.replace(/\s+/g, '-')
		.toLowerCase();

	return (
		<div className={styles.filter}>
			<input
				name={props.filterValue}
				type="checkbox"
				className={styles.filterInput}
				checked={props.checked}
				onChange={props.handleInputChange}
				id={filterCheckboxID}
			/>
			<label htmlFor={filterCheckboxID} className={styles.filterLabel}>
				{props.filterName}
			</label>
		</div>
	);
}

export interface FilterProps {
	checked: boolean;
	filterFor: string;
	filterName: string;
	filterValue: string;
	handleInputChange: ChangeEventHandler<HTMLInputElement>;
}

export default Filter;
